module.exports = __webpack_public_path__ + "img/shimensenlingongyuan.db1bd43b.png";